export const PORTFOLIO_SCORE_CHECKLIST = [
  {
    id: 'json-role-positioning',
    label: 'Role positioning is clear and specific',
    description: 'Top content clearly states role focus, seniority, and value proposition using title/subtitle/paragraph nodes.',
    weight: 8,
  },
  {
    id: 'json-project-evidence-quality',
    label: 'Project evidence quality is strong',
    description: 'Project-related nodes and nearby text explain problem, actions, tools, and outcomes with concrete evidence.',
    weight: 11,
  },
  {
    id: 'json-skills-traceability',
    label: 'Skills are traceable to work examples',
    description: 'Skills nodes include non-empty skillIds and are supported by project or paragraph evidence in the JSON.',
    weight: 9,
  },
  {
    id: 'context-role-fit-score',
    label: 'Portfolio shows fit for desired jobs',
    description: 'Using Candidate context (desired jobs, projects, skills, images), evaluate whether the portfolio demonstrates role-relevant strengths and gaps.',
    weight: 10,
  },
  {
    id: 'json-technical-depth',
    label: 'Technical depth and trade-offs are visible',
    description: 'Paragraph/list content explains architecture decisions, constraints, trade-offs, and implementation details.',
    weight: 9,
  },
  {
    id: 'json-impact-metrics',
    label: 'Impact metrics are evidenced',
    description: 'Text or list nodes include measurable outcomes such as percentages, scale, time savings, throughput, or quality gains.',
    weight: 8,
  },
  {
    id: 'json-architecture-readability',
    label: 'JSON architecture is readable and complete',
    description: 'Content is organized with section and layout nodes (col-2/col-3/col-4 where needed) and avoids overloaded single blocks.',
    weight: 7,
  },
  {
    id: 'context-image-narrative-support',
    label: 'Images support the professional narrative',
    description: 'Images referenced or available in context reinforce project credibility, technical work, or outcomes rather than generic decoration.',
    weight: 6,
  },
  {
    id: 'json-cta-trust-links',
    label: 'Call-to-action and trust links are present',
    description: 'At least one actionable link node exists for contact, CV, GitHub, or other hiring next step and the text is meaningful.',
    weight: 6,
  },
  {
    id: 'json-copy-quality-focus',
    label: 'Copy quality is concise and role-focused',
    description: 'Language is concise, specific, and avoids filler while maintaining a professional tone aligned to hiring goals.',
    weight: 6,
  },
];

export const getPortfolioChecklistMaxScore = () =>
  PORTFOLIO_SCORE_CHECKLIST.reduce((sum, item) => sum + Number(item.weight || 0), 0);
